export default {
    landing: {
        title: 'Bitdeer App',
        sub: '一站式比特币挖矿',
        desc: '登记、累积、提现、看算力产出，全部在 App 里完成',
        register: '立即注册',
        login: '已有账号？登录',
        feature1: '预约奖励 10 USDT / 天',
        feature2: '满 10 USDT 随时提取，0 手续费',
        feature3: '24 小时日文客服'
    },
    login: {
        title: '登录',
        sub: '欢迎回来',
        email: '电子邮箱',
        emailPlaceholder: '请输入电子邮箱',
        password: '密码',
        passwordPlaceholder: '请输入密码',
        submit: '登录',
        noAccount: '没有账号？',
        register: '立即注册',
        success: '登录成功',
        emailRequired: '请输入邮箱',
        emailInvalid: '邮箱格式不正确',
        passwordRequired: '请输入密码'
    },
    register: {
        title: '注册',
        sub: '开启您的挖矿之旅',
        email: '电子邮箱',
        emailPlaceholder: '请输入电子邮箱',
        code: '验证码',
        codePlaceholder: '输入验证码',
        sendCode: '发送验证码',
        resend: '重新发送（{s}s）',
        codeSent: '验证码已发送',
        password: '密码',
        passwordPlaceholder: '至少 6 位',
        referral: '推荐码',
        referralPlaceholder: '请输入推荐码',
        agree: '我已阅读并同意',
        terms: '服务条款',
        and: '及',
        privacy: '用户协议',
        submit: '立即注册',
        hasAccount: '已有账号？',
        login: '立即登录',
        success: '注册成功',
        emailRequired: '请输入邮箱',
        emailInvalid: '邮箱格式不正确',
        codeRequired: '请输入验证码',
        passwordRequired: '请输入密码',
        passwordTooShort: '密码至少 6 位',
        referralRequired: '请输入推荐码',
        agreeRequired: '请先同意服务条款',
        registerSuccess: '注册成功，请登录'
    },
    success: {
        title: '预约成功！',
        sub: '您的账号已准备就绪',
        userId: '用户 ID',
        email: '电子邮箱',
        inviteCode: '您的邀请码',
        copy: '复制',
        copied: '邀请码已复制',
        tip: '将邀请码分享给好友，好友注册后您将成为他的上级',
        downloadAndroid: 'Android 下载',
        downloadIos: 'iOS 下载',
        platformTip: '您预约的是 {platform} 版本',
        backHome: '返回首页'
    }
}